/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function BrandingDistributionOverridesModalController(this: JS5Object, PermissionsService: JS5Object) {

	//======//
	// Data //
	//======//

	let getWritePermission = (): JS5Promise => {
		return PermissionsService.getPermissionsForViewState(this.resolve.viewState)
			.then((viewStatePerm: JS5Object): void => {
				this.overrideContext.canWriteOverrides = PermissionsService.hasWritePermission(viewStatePerm.permission);
			});
	};


	//=================//
	// Lifecycle Hooks //
	//=================//

	this.$onInit = () => {
		this.partnerPackage = this.resolve.partnerPackage;

		this.overrideContext = {
			packageObject: this.resolve.packageObject,
			viewState: this.resolve.viewState,
			readOnly: this.resolve.readOnly,
			canWriteOverrides: false,
		};

		getWritePermission();

		this.overrideAssetDescriptors = {
			watermark: {
				displayName: 'Watermark',
				seasonVolumeFlagPropertyName: 'watermarkSeasonVolume',
				basePropertyName: 'watermark',
				overridePropertyName: 'watermarkOverride',
				overrideFlagPropertyName: 'watermarkOverridden',
				containerAssetsPropertyName: 'assets',
				previewPropertyDescriptors: [
					{
						label: 'Watermark',
						subPropertyName: null,
					},
				],
			},
			preRoll: {
				displayName: 'Preroll',
				seasonVolumeFlagPropertyName: 'preRollSeasonVolume',
				basePropertyName: 'preRoll',
				overridePropertyName: 'preRollOverride',
				overrideFlagPropertyName: 'preRollOverridden',
				containerAssetsPropertyName: 'assets',
				previewPropertyDescriptors: [
					{
						label: 'Preroll',
						subPropertyName: null,
					},
				],
			},
			postRoll: {
				displayName: 'Postroll',
				seasonVolumeFlagPropertyName: 'postRollSeasonVolume',
				basePropertyName: 'postRoll',
				overridePropertyName: 'postRollOverride',
				overrideFlagPropertyName: 'postRollOverridden',
				containerAssetsPropertyName: 'assets',
				previewPropertyDescriptors: [
					{
						label: 'Postroll',
						subPropertyName: null,
					},
				],
			},
			breakPrePostRoll: {
				displayName: 'Break Pre/Postroll',

				//
				// 2017-Nov-14 - Uncomment the following line to
				// enable season/volume break pre and post rolls
				// once they are supported
				//

				// seasonVolumeFlagPropertyName: 'breakPrePostRollSeasonVolume',
				basePropertyName: 'breakPrePostRoll',
				overridePropertyName: 'breakPrePostRollOverride',
				overrideFlagPropertyName: 'breakPrePostRollOverridden',
				containerAssetsPropertyName: 'breakPrePostRolls',
				previewPropertyDescriptors: [
					{
						label: 'Preroll',
						subPropertyName: 'preRoll',
					},
					{
						label: 'Postroll',
						subPropertyName: 'postRoll',
					},
				],
			},
		};
	};

}

angular
.module('prism-ui.package')
.component('brandingDistributionOverridesModal', {
	controller: BrandingDistributionOverridesModalController,
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&',
	},
	templateUrl: 'package/editor/components/modals/brandingDistributionOverrides/branding-distribution-overrides-modal-template.html',
});
